export default "__VITE_ASSET__ozkGLdpQ__"